var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrap short"},[_c('div',{staticClass:"title"},[_vm._v("Bookings")]),_c('div',{staticClass:"subtitle"},[_vm._v(_vm._s(_vm._f("formatNumbers")(this.totalBookings)))])])
}
var staticRenderFns = []

export { render, staticRenderFns }